// /**
// =========================================================
// * Material Dashboard 2 React - v2.2.0
// =========================================================

// * Product Page: https://www.creative-tim.com/product/material-dashboard-react
// * Copyright 2023 Creative Tim (https://www.creative-tim.com)

// Coded by www.creative-tim.com

//  =========================================================

// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
// */

import { useState,useEffect } from "react";
import axios from 'axios';
import {url,urlLive} from '../../../constant';
// react-router-dom components
import { Link } from "react-router-dom";

//  @mui material full-page-loader
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";
import Grid from "@mui/material/Grid";
import MuiLink from "@mui/material/Link";

// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import GitHubIcon from "@mui/icons-material/GitHub";
import GoogleIcon from "@mui/icons-material/Google";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";
import { Navigate, useLocation  } from 'react-router-dom';

// Images
import bgImage from "assets/images/bg-sign-in-basic.jpeg";

function SignIn() {
  const [rememberMe, setRememberMe] = useState(false);
  // const [email,setEmail] = useState('rizwaneng6@gmail.com');
  const [email,setEmail] = useState('');
  const [password,setPassword] = useState('');
  const [loggedIN,setLoggedIN] = useState(false);
  const [open, setOpen] = useState(false);

  const locations = useLocation();
  const queryParams = new URLSearchParams(locations.search);
  const requestId = queryParams.get('requestId');

  const handleSetRememberMe = () => setRememberMe(!rememberMe);


  useEffect(()=>{

    const udata = localStorage.getItem('user');
    
    if (udata !== null) {
      setLoggedIN(true);
    }

  },[]);

  function onChangeUserEmail(e) {
    setEmail(e.target.value);
    console.log(e.target.value);

  }

  function onChangePassword(e) {
    setPassword(e.target.value);
  }

  function onSubmit(e) {
    e.preventDefault()


    const userObject = {
      email: email,
      password: password
    };
    setOpen(true);
    axios.post(`${url}auth/login`, userObject)
      .then((res) => {
        // console.log(res);
        if (res.status === 200) {
          setLoggedIN(true);
          localStorage.setItem('user', JSON.stringify(res.data));

          // Example usage with dynamic date and time
          createAccess(res.data.user.IdUser, "admin");

          setOpen(false);
        }
      }).catch((error) => {
        setOpen(false);
        alert(error.response.data.error);
        // if(error.status == 422){
            
        //     setOpen(false);
        //     console.log(error.response.data.error);
        //     alert(error.response.data.error);
           
        // }else if (error.status == 401){
          
        //   setOpen(false);
        //   alert(error.response.data.error);
          
        // }else if (error.status == 403){
          
        //   setOpen(false);
        //   alert(error.response.data.error);
          
        // }else{

        // }

      });
    
    setEmail('');
    setPassword('');

  }


  function createAccess(IdUser, CreationUser) {
    // Get current date and time in the format YYYY-MM-DD HH:MM:SS
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().slice(0, 19).replace("T", " "); // Converts to "YYYY-MM-DD HH:MM:SS"
  
    const formdata = new FormData();
    formdata.append("IdUser", IdUser);
    formdata.append("DateAccess", formattedDate); // Use the formatted current date
    formdata.append("CreationUser", CreationUser);
  
    const requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow"
    };
  
    fetch(`${url}auth/create-accesses`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if(requestId){
          window.location.href = `/Richieste-Dettagli?requestId=${requestId}`
        }
        // console.log("Success:", result);
      })
      .catch((error) => {
        console.error("Error:", error);
      });

  }
  
  // // Example usage with dynamic date and time
  // createAccess("10", "admin");
  

  if (loggedIN){
    
      return <Navigate  to="/dashboard"/>
   
    
  }

  return (
    <BasicLayout >
      <Backdrop
        sx={{
          color: '#fff',
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent black
        }}

        open={open}
        transitionDuration={500}  // Smooth transition for the backdrop
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          // coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
          // sx={{
          //   background: '#6281eb', // Initial background color
          //   "&:hover": {
          //     background: '#4a65d8', // Hover state ke liye color
          //   },
          // }} 

          sx={{
            background: '#183759', // 🔹 Your main color
            "&:hover": {
              background: '#204b80', // ✨ Slightly lighter for hover
            },
          }}

        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Log in
          </MDTypography>
          {/* <Grid container spacing={3} justifyContent="center" sx={{ mt: 1, mb: 2 }}>
            <Grid item xs={2}>
              <MDTypography component={MuiLink} href="#" variant="body1" color="white">
                <FacebookIcon color="inherit" />
              </MDTypography>
            </Grid>
            <Grid item xs={2}>
              <MDTypography component={MuiLink} href="#" variant="body1" color="white">
                <GitHubIcon color="inherit" />
              </MDTypography>
            </Grid>
            <Grid item xs={2}>
              <MDTypography component={MuiLink} href="#" variant="body1" color="white">
                <GoogleIcon color="inherit" />
              </MDTypography>
            </Grid>
          </Grid> */}
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form">
            <MDBox mb={2}>
              <MDInput type="email" label="Email" fullWidth value={email} onChange={onChangeUserEmail} />
            </MDBox>
            <MDBox mb={2}>
              <MDInput type="password" label="Password" fullWidth value={password} onChange={onChangePassword} />
            </MDBox>
            {/* <MDBox display="flex" alignItems="center" ml={-1}>
              <Switch checked={rememberMe} onChange={handleSetRememberMe} />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                onClick={handleSetRememberMe}
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Remember me
              </MDTypography>
            </MDBox> */}
            <MDBox display="flex" alignItems="center" justifyContent="flex-end"  >

              <MDTypography
                variant="caption"
                fontWeight="regular"
                color="text"
                // onClick={handleSetRememberMe}
                sx={{
                  cursor: "pointer", userSelect: "none", mr: 0.5,
                  fontSize: '0.68rem' // Adjust this value as needed
                }}
                component={Link}
                to="/authentication/reset-password/cover"

              >
                &nbsp;&nbsp;Password dimenticata?
              </MDTypography>

            </MDBox>

            <MDBox mt={2} mb={1}>
              <MDButton variant="gradient" color="info" 
              
              // sx={{
              //   background: '#6281eb', // Initial background color
              //   "&:hover": {
              //     background: '#4a65d8', // Hover state ke liye color
              //   },
              // }}

              sx={{
                background: '#183759', // 🔹 Your main color
                "&:hover": {
                  background: '#204b80', // ✨ Slightly lighter for hover
                },
              }}
              
              fullWidth
              onClick ={onSubmit}
              >
                Log in
              </MDButton>
            </MDBox>
            <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                {/* Don&apos;t have an account?{" "} */}
                {/* Non&apos;hai un account?{" "}

                <MDTypography
                  component={Link}
                  to="/authentication/sign-up"
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  textGradient
                  sx={{
                    background: 'linear-gradient(to right, #6281eb, #4a65d8)', // Gradient color
                    WebkitBackgroundClip: 'text',
                    color: 'transparent', // Ensures that the text is transparent so that gradient is visible
                  }}

                >
                  Contattaci
                </MDTypography> */}
                
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
  
}



export default SignIn;
